export default "__VITE_ASSET__a38e9aee__"